import { Cookies } from "react-cookie";
import { decodeToken } from "react-jwt";

export const CLAIM_AUTH_COOKIE = "CompanyClaimAuthorization";

function getCookies() {
	return new Cookies();
}

function getTokenExpiration(token) {
	const decodedToken = decodeToken(token);
	if (!decodedToken?.exp) {
		return null;
	}
	return new Date(decodedToken.exp * 1000);
}

export function getClaimToken() {
	return getCookies().get(CLAIM_AUTH_COOKIE) || null;
}

export function decodeClaimToken(token = getClaimToken()) {
	if (!token) {
		return null;
	}

	try {
		const decodedToken = decodeToken(token);
		const reviewToken = decodedToken?.data?.review_token;
		const claimPayload = typeof reviewToken === "string" ? JSON.parse(reviewToken) : null;

		if (!claimPayload?.companyId) {
			return null;
		}

		return {
			...claimPayload,
			expiresAt: getTokenExpiration(token)?.toISOString() || null,
		};
	} catch {
		return null;
	}
}

export function hasValidClaimSession(token = getClaimToken()) {
	if (!token) {
		return false;
	}

	const claimSession = decodeClaimToken(token);
	if (!claimSession?.companyId) {
		return false;
	}

	const expiresAt = getTokenExpiration(token);
	return Boolean(expiresAt && expiresAt.getTime() > Date.now());
}

export function setClaimSession(token, expiresAt) {
	if (!token) {
		return;
	}

	const expirationDate = expiresAt ? new Date(expiresAt) : getTokenExpiration(token);

	getCookies().set(CLAIM_AUTH_COOKIE, token, {
		path: "/",
		...(expirationDate ? { expires: expirationDate } : {}),
	});
}

export function clearClaimSession() {
	getCookies().remove(CLAIM_AUTH_COOKIE, {
		path: "/",
	});
}

